<template>
  <div id="w_box">
    <Header :searchPage="searchPage" @goPage="goPage"></Header>
    <div class="content">
      <div class="con_w">
        <WhrSearch/>
         <div id="tab03" class="con act">
          <div class="tbl">
            <table>
              <colgroup>
                <col width="75">
                <col width="*">
                <col width="65">
                <col width="105">
                <col width="65">
                <col width="65">
                <col width="65">
                <col width="65">
                <col width="65">
                <col width="65">
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" rowspan="2" class="tp fst">종목코드</th>
                  <th scope="col" rowspan="2" class="tp">종목명</th>
                  <th scope="col" rowspan="2" class="tp">기준</th>
                  <th scope="col" rowspan="2" class="tp">
                    <select id="turnVal" v-model="searchPage.turnVal" @change="goTurnPage()">
                      <option v-for="(option,index) in searchPage.turnVals" v-bind:value="option.value" :key="index">{{option.text}}</option>
                    </select>
                  </th>
                  <th scope="col" colspan="3" class="tp">당기순이익<em>(USD mm)</em></th>
                  <th scope="col" colspan="3" class="tp lst">수익률<em>(%)</em></th>
                </tr>
                <tr>
                  <th scope="col">최근</th>
                  <th scope="col">전년동기</th>
                  <th scope="col">증가율<em>(%)</em></th>
                  <th scope="col">1주</th>
                  <th scope="col">1개월</th>
                  <th scope="col" class="lst">3개월</th>
                </tr>
              </thead>
              <tbody>
              <template v-for="(item,index) in searchPage.items">
                <CrecordSub :item="item" :key="index"/>
              </template>
              </tbody>
            </table>
            <!-- //table -->
            </div>
            <!-- //tbl -->

            <Pagination :searchPage="searchPage" @goPage="goPage"/>
            <!-- //paging -->

            <div class="guide">
            * 어닝 판단 기준 : 희석주당순이익 컨센서스 대비 변화율 <br>
            * 출처 : EDGAR 실적공시(8-K, 10-Q, 10-K), GAAP기준 (Non-GAAP 확보시 우선 적용) <br>
            * 공시 규격 6-K의 ADR종목은 제공되지 않음
            </div>
            <!-- //guide -->

            <div class="time">
              한국시간 기준 {{ curTime }}
            </div>
            <!-- //time -->
        </div>
      </div>
   </div>
  </div>
</template>

<script>
import Header from '@/components/kiwoom/usRecord/pc/common/Header'
import WhrSearch from '@/components/kiwoom/usRecord/pc/common/WhrSearch'
import CrecordSub from '@/views/kiwoom/usRecord/pc/Crecord_sub'
import {mapGetters} from 'vuex'
import Pagination from '@/components/common/Pagination'
import axios from 'axios'
import { EventBus } from '@/store/event-bus'

export default {
  components: {
    Header,
    WhrSearch,
    CrecordSub,
    Pagination
  },
  data () {
    return {
      searchPage: {
        pageNo: 1,
        pageSize: 14,
        totalRows: 0,
        items: [],
        turnVal: 'ALL',
        turnVals: [
          {text: '턴어라운드', value: 'ALL'},
          {text: '적자전환', value: 'turnA'},
          {text: '흑자전환', value: 'turnB'}
        ]
      },
      curTime: new Date().toLocaleString()
    }
  },
  methods: {
    init () {
      const params = {
        chkIndex: this.getUsRecordSettings.chkIndex,
        pageNo: this.searchPage.pageNo,
        pageSize: this.searchPage.pageSize,
        symbol: this.getUsRecordSettings.symbol,
        turnVal: this.searchPage.turnVal
      }
      this.$store.dispatch('setLodingBarSetting', true)

      let postUrl = 'https://security.thinkpool.com/api/us/kw/taround/getUsStockDataListAjax.do'
      axios.post(postUrl, params).then((res) => {
        if (res.data.resCode === '1') {
          this.searchPage.totalRows = res.data.resObj.totalRows
          this.searchPage.items = res.data.resObj.mlist
          this.curTime = new Date().toLocaleString()
        }

        this.$store.dispatch('setLodingBarSetting', false)
      })
    },
    goPage (pageNo) {
      this.searchPage.pageNo = parseInt(pageNo)
      this.init()
    },
    goTurnPage () {
      this.searchPage.turnVal = $('#turnVal').val()
      this.goPage('1')
    },
    setSymbolDataReset () {
      localStorage.setItem('symbol', '')
      localStorage.setItem('syName', '')
      this.$store.dispatch('saveUsSymbolSetting', '')
      this.$store.dispatch('saveUsSyNameSetting', '')
    }
  },
  computed: {
    ...mapGetters(['getUsRecordSettings']),
    getChkIndex () {
      return this.getUsRecordSettings.chkIndex
    },
    getSymbol () {
      return this.getUsRecordSettings.symbol
    },
    getSyName () {
      return this.getUsRecordSettings.syName
    },
    getPageNo () {
      return this.searchPage.pageNo
    }
  },
  created () {
    if (this.getUsRecordSettings.chkIndex !== 'SYMBOL') {
      this.setSymbolDataReset()
    }

    this.goPage('1')

    EventBus.$on('pageNo', (val) => {
      this.searchPage.pageNo = val
    })
  },
  watch: {
    getChkIndex (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('chkIndex', val)
        if (val !== 'SYMBOL') {
          this.setSymbolDataReset()
        }
        this.searchPage.totalRows = 0
        this.goPage('1')
      }
    },
    getSymbol (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('symbol', val)
        this.goPage('1')
      }
    },
    getSyName (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('syName', val)
      }
    },
    getPageNo (val, oldVal) {
      if (val !== oldVal) {
        EventBus.$emit('pageNo', val)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/kiwoom/usRecord/pc/Crecord.vue